<script lang="ts">
  import { twMerge } from 'tailwind-merge';

  export let tag: string = 'li';
</script>

<svelte:element
  this={tag}
  class={twMerge('text-sm font-medium transition-colors duration-200', $$restProps.class)}
>
  <slot />
</svelte:element>

<!--
@component
Simple,semantic wrapper for items places within a dropdown.
## Props
@prop `tag`: string = 'li';
-->
